// 个人中心
export default [
  {
    path: '/profile',
    name: 'profile',
    component: () => import(/* webpackChunkName: "profile" */ '@/views/profile/Index.vue'),
    meta: { title: '个人中心' },
    redirect: '/profile/baseinfo',
    children: [
      {
        path: 'baseinfo',
        name: 'profile-baseinfo',
        component: () => import(/* webpackChunkName: "profile" */ '@/views/profile/BaseInfo.vue'),
        meta: { title: '个人信息' },
      },
      {
        path: 'password',
        name: 'profile-password',
        component: () => import(/* webpackChunkName: "profile" */ '@/views/profile/Password.vue'),
        meta: { title: '修改密码' },
      },
      {
        path: 'settings',
        name: 'profile-home-module',
        component: () => import(/* webpackChunkName: "profile" */ '@/views/profile/HomeSettings.vue'),
        meta: { title: '首页功能' },
      },
    ],
  },
];
